(function() {
'use strict';
  
  angular
    .module('app.metrics')
    .factory('metrics', metrics);
      
  metrics.$inject = ['$log', '$state', 'marsService', 'version'];
    
  function metrics($log, $state, marsService, version) {
    $log = $log.getInstance('metrics');
    
    return {
      log: log
    };

    function log(name) {
      return marsService.publish('/metrics', {
        name: name,
        version: version,
        source: $state.current.name
      });
    }
  }
  
})();
